import { type FireAnalyticsEvent } from '../../types';

export const onDebugPanelShown = (): FireAnalyticsEvent => ({
	eventType: 'operational',
	action: 'shown',
	actionSubject: 'debugPanel',
	attributes: {},
});
